; (function (jQuery) {

	"use strict";

	function Main() {
		var global = {
			navExpanded: false
		};

		var fn = {
			init: function ()
			{
				jQuery('.no-js').removeClass('no-js');

				jQuery('.nav-bar__menu-btn').on('click', fn.handleMenuExpansion);

				jQuery('.faqs__question').on('click', fn.handleFAQExpansion);

				jQuery('.match-height').matchHeight();
				jQuery('.match-height-sub-1').matchHeight();
				jQuery('.match-height-sub-2').matchHeight();
				jQuery('.match-height-sub-3').matchHeight();
				jQuery('.match-height').matchHeight(); // Repeated

				// Iframe responsive layouts
				jQuery('iframe').each(fn.wrapIframes); 
				jQuery('.calculate-aspect-ratio').each(fn.calculateAspectRatio);

				jQuery('.gallery-slider__container').each(fn.gallerySlider); // Gallery Slider

				// Subscribe Form Edits
				jQuery('.sib_signup_form').each(fn.subscribeFormEdits);
			},


			handleMenuExpansion: function()
			{
				var navBarMenu = jQuery('.nav-bar__menu');
				var navBarButton = jQuery('.nav-bar__menu-btn');
				var navBarMenuIcon = jQuery('.nav-bar__menu-icon');
				if (!global.navExpanded)
				{
					global.navExpanded = true;
					navBarMenu.addClass('nav-bar__menu--active');
					navBarButton.attr('aria-expanded', 'true');
					navBarMenuIcon.addClass('nav-bar__menu-icon--active');
				}
				else
				{
					global.navExpanded = false;
					navBarMenu.removeClass('nav-bar__menu--active');
					navBarButton.attr('aria-expanded', 'false');
					navBarMenuIcon.removeClass('nav-bar__menu-icon--active');
				}
			},


			handleFAQExpansion: function()
			{
				var FAQItem = jQuery(this).closest('.faqs__item');
				var FAQAnswer = FAQItem.find('.faqs__answer');
				if (FAQItem.hasClass('faqs__item--open'))
				{
					FAQItem.removeClass('faqs__item--open');
					FAQAnswer.slideUp(100);
				}
				else
				{
					FAQItem.addClass('faqs__item--open');
					FAQAnswer.slideDown(100);
				}
			},

			// Responsive Videos & Google Maps
			// 1. Wrap any iframes with aspect ratio calculation div (if not already wrapped in templates)
			wrapIframes: function(i, iframe)
			{
				if (!jQuery(iframe).parent('.calculate-aspect-ratio').length)
				{
					// Check that iframe is not in certain modules
					if (!jQuery(iframe).closest('.opentable-module').length)
					{
						jQuery(iframe).wrap('<div class="calculate-aspect-ratio"></div>');
					}
				}
			},
			// 2. Calculate Aspect Ratio of iFramed content
			// Uses padding-bottom % to allow responsive iFrames
			calculateAspectRatio: function(i, container)
			{
				// Responsive Iframes
				var iframe = jQuery(container).find('iframe');
				if (iframe.length) {
					var height = iframe.attr('height');
					var width = iframe.attr('width');
					if (!isNaN(height) && !isNaN(width) && (+height + +width) > 0) {
						var ratio = height / width * 100;
						jQuery(container).css('padding-bottom', ratio + '%');
					}
				}
				// EU Cookie fix - to prevent zero padding-bottom
				var euCookie = jQuery(container).find('.eucookie');
				if (euCookie.length) {
					jQuery(container).css('padding-bottom', '180px');
				}
			},

			// Slick Slider - Uses jQuery each to bind prev / next with each slider
			gallerySlider: function(i, gallery)
			{
				var slider = jQuery(gallery).find('.gallery-slider');
				var next = jQuery(gallery).find('.gallery-slider__arrow--next');
				var prev = jQuery(gallery).find('.gallery-slider__arrow--prev');
				slider.slick({
					lazyLoad: 'progressive',
					infinite: true,
					rows: 0,
					prevArrow: prev,
					nextArrow: next
				});
			},

			// Subscribe Form Edits
			subscribeFormEdits: function(i, subForm)
			{
				jQuery(subForm).find('.sib-email-area').attr('placeholder', "Email");
				jQuery(subForm).find('.sib-NAME-area').attr('placeholder', "Name");
				//jQuery(subForm).find('.sib_msg_disp').show().append('<p class="sib-alert-message sib-alert-message-success " >Thank you, you have successfully registered !</p>');
			}

		}

		jQuery(fn.init);
	}

	new Main();
})(jQuery);